import { useState } from "react";
import ClientAbonItemMain from "./client-abon-item-main";
import ClientAbonItemStatus from "./client-abon-item-status";
import ClientAbonItemPayments from "./client-abon-item-payments";
import ClientAbonItemPackets from "./client-abon-item-packets";
import { Button, Space, Tabs, message, Popconfirm } from "antd";
import { serverFetch } from "../../server";
import { isMobile, menuSize } from "../../extensions/design";
import ButtonReport from "../../controls/button-report/button-report";
  
const { TabPane } = Tabs;
const ClientAbonItem = ({ id, status, onAbonsUpdate, abon }) => {
  const [activeTab, setActiveTab] = useState("1");
  const [loading, setLoading] = useState(false);

  const onSave = () => {
    setLoading(true);
    serverFetch("visit", { method: "POST", bodyData: {saleId:id, status:status}})
      .then((response) => {
        setLoading(false)
        message.success(`Визит #${response.id} успешно открыт`);
      })
      .catch(e => {
        message.error(e.userMessage);
        setLoading(false);
      })
  } 

  const onPrint = () => {
    const url = `report?reportId=1&id=${id}`;
    window.open(url, '_blank');
    // serverFetch(`report/design?reportId=1&id=${id}`)
    //   .then(data => console.log(data))
    //   .catch(data => message.error(data.userMessage));
  }
  
  return (
    <>
      <div className={!isMobile ? "" : "client-item-content"}>
        <Tabs activeKey={activeTab} onChange={setActiveTab} type="line" className={!isMobile ? "no-custom-tabs" : "no-custom-tabs no-custom-tabs-mobile no-custom-tabs-mobile-client-abons-tabs"}>
          <TabPane tab="Основная" key="1">
            {activeTab === "1" && <ClientAbonItemMain saleId={id} onAbonsUpdate={onAbonsUpdate}/>}
          </TabPane>  
          <TabPane tab="Статус" key="2">
            {activeTab === "2" && <ClientAbonItemStatus id={id} onAbonsUpdate={onAbonsUpdate}/>}
          </TabPane>
          <TabPane tab="Платежи" key="3">
            {activeTab === "3" && <ClientAbonItemPayments id={id} onAbonsUpdate={onAbonsUpdate} abon={abon}/>}
          </TabPane>
          <TabPane tab="Пакеты" key="4">
            {activeTab === "4" && <ClientAbonItemPackets id={id} onAbonsUpdate={onAbonsUpdate}/>}
          </TabPane>
        </Tabs>
        {!  isMobile ? 
        <Space>
          <Popconfirm title="Подтверждение" description="Открыть визит?" onConfirm={onSave}>
            <Button disabled={!id || loading || status !== 2 || abon.productVid !== 2}>Открыть визит</Button>
          </Popconfirm>
          <ButtonReport vid={4} id={id} />
        </Space> : 
        <Popconfirm title="Подтверждение" description="Открыть визит?" onConfirm={onSave}
          placement="top" getPopupContainer={(trigger) => trigger.closest('.client-item-line-double-halfed')} overlayClassName="centered-popconfirm">
          <Button type="primary" disabled={!id || loading || status !== 2 || abon.productVid !== 2} style={{width:"100%", marginTop: 4}}>Открыть визит</Button>
        </Popconfirm>}
      </div>
    </>
  );
};
export default ClientAbonItem;
